export enum DialogType {
    snackbar = 'SNACKBAR',
    dialog = 'DIALOG',
}
